import { initializeCartURL } from '@services/urls/apiGatewayURLs';
import ServiceResponse from '@services/models/ServiceResponse';

const message = 'restaurantId param or fromOrderId param are required';

async function initializeCart({
  axios,
  restaurantId,
  location,
  fromOrderId,
  userApplication,
  pickUp,
  businessType,
}) {
  try {
    if (!restaurantId && (!fromOrderId || !Number(fromOrderId))) {
      return new ServiceResponse({ message });
    }

    const initializationData = {};

    if (businessType) {
      initializationData.businessType = businessType;
    }

    if (restaurantId) {
      initializationData.restaurant = restaurantId;
    }

    if (fromOrderId) {
      initializationData.fromOrder = Number(fromOrderId);
    }

    if (location) {
      if (location.id) {
        initializationData.address = location.id;
      } else {
        initializationData.lat = location.latitude;
        initializationData.lng = location.longitude;
      }
    }

    if (userApplication) initializationData.userApplication = userApplication;
    if (pickUp) initializationData.pickUp = pickUp;

    const response = await axios.post(initializeCartURL, initializationData);
    return new ServiceResponse({ data: response.data });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default initializeCart;
